import type { AvailableGameCatalogEntry } from '../../catalog-entry.js';
import { sortableTestDescriptor } from './descriptor.js';

export const sortableTestCatalogEntry = {
  descriptor: sortableTestDescriptor,
  availability: 'diagnostic',
  load: async () => (await import('./sortable-test.js')).sortableTestDefinition,
} satisfies AvailableGameCatalogEntry;
